import { Input } from '@angular/core';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { OrderType } from '../../pages/list-page/list-page.component';
import { IStore, StoreService } from '../../services/store.service';
import { ValidatorsService } from 'src/app/shared/services/validators.service';
import { ICustomTipCell, ITipCell, SettingService } from 'src/app/shared/services/setting.service';

export interface ICheckoutTipForm {
  amount: number;
}

@Component({
    selector: 'store-checkout-tip-form',
    templateUrl: './checkout-tip-form.component.html',
    styleUrls: ['./checkout-tip-form.component.scss'],
    standalone: false
})
export class CheckoutTipFormComponent implements OnInit {
  //isDoorDashDriveUser:boolean = false;
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();
  showTipInput: boolean = false;
  currentTipSelected: number = -1;

  patternReference: any = {};

  private _orderType: OrderType;
  private _subTotal: number;
  private storeService: StoreService;
  @Input() store: IStore;
  @Output()
  onSubmit: EventEmitter<ICheckoutTipForm> = new EventEmitter<ICheckoutTipForm>();

  tipSetup: ITipCell[] = []; 
  tipCustomSetup: ICustomTipCell[] = []; 
  minimumRegularTipCells = 5;
  minimumCustomTipCells = 1;

  TipAmountMap = {
    1: 0,
    2: 15,
    3: 18,
    4: 20,
    5: 25
  };

  minTip: number = 0;

  disableTip: boolean = false;

  @Input() set orderType(orderType: OrderType)
  {
    this._orderType = orderType; 
  }

  @Input() set subTotal(subtotal: number)
  {
      this._subTotal = subtotal;
  }

  get orderType(): OrderType {
    return this._orderType;
  }

  get subtotal(): number {
    return this._subTotal;
  }

   get currentTipValue(): number {
    return this.form.get("tip").value;
  }

  constructor(
    private fb: FormBuilder,
    public validators: ValidatorsService,
    public settingService: SettingService
  ) {

  }
 
  ngOnInit() {
    this.setupTip();

    /*
    this.form = this.fb.group({
      //'tip': [0, this.validators.formBuilderValidationInitializer(true, 7)]
      'tip': [0, [Validators.min(this.tipCustomSetup[0].tipCellamount)]]
    }, {
      validators: [ ]
    });
    */

    this.form = this.fb.group({
      tip: this.fb.control(0, {
        validators: this.validators.formBuilderValidationInitializer(true, 7),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      tip: 7
    };
    */
    this.patternReference = {
      tip: 7
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);

    this.submit();

    if(this.store.isDoorDashDrive && this.orderType == "delivery"){
      this.calculateTip(20)
    }

  }

  setupTip() {
    if(this.settingService.configuration.tipConfig != null) {
      var noActiveCell = true;
      if(this.settingService.configuration.tipConfig.tipCells) {
        this.tipSetup = this.settingService.configuration.tipConfig.tipCells;
        for(var i = 0; i < this.tipSetup.length; i++) {
          if(!this.tipSetup[i].hideTipCell) {
            noActiveCell = false;
          }
        }

      }

      if(this.settingService.configuration.tipConfig.customTipCells) {
        this.tipCustomSetup = this.settingService.configuration.tipConfig.customTipCells;
        for(var i = 0; i < this.tipCustomSetup.length; i++) {
          if(!this.tipCustomSetup[i].hideTipCell) {
            noActiveCell = false;
          }
        }
      }

      if(noActiveCell) {
        this.disableTip = true;
      }
    } else {

      for (var i = 0; i < this.minimumRegularTipCells; i++) {
        this.tipSetup.push({
          cellType: "percent",
          hideTipCell: false,
          tipCellamount: this.TipAmountMap[i + 1]
        })
      }

      for (var i = 0; i < this.minimumCustomTipCells; i++) {
        this.tipCustomSetup.push({
          cellType: "straightmoney",
          hideTipCell: false,
          tipCellamount: 0
        })
      }

    }
  }

  submit() {
    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));


    if (!this.form.valid) {
      this.onSubmit.emit({
        amount: 0
      });
      return;
    }

    this.formErrors.clear();

    let value = this.form.get("tip").value;
    this.onSubmit.emit({
      amount: value
    });
  }

  calculateTip(amount:number) {
    this.currentTipSelected = amount;

    if (amount == 0) {
      this.form.get("tip").setValue(0);
      this.showTipInput = false;
    }
    
    if (amount == null) {
      this.form.get("tip").setValue(this.tipCustomSetup[0].tipCellamount);
      this.minTip = this.tipCustomSetup[0].tipCellamount;
      this.showTipInput = true;     
    } else {
      this.form.get("tip").setValue(parseFloat(((amount / 100) * this._subTotal).toFixed(2)));     
      this.showTipInput = false;
    }

    this.submit();
  }
}
